export const DevIndicator = () => {
    const isDev = process.env.REACT_APP_CURRENT_ENV === "dev";

    if (!isDev) return null;

    return (
        <div className="fixed top-0 left-1 text-red-600 text-sm">dev env</div>
    );
};